module.exports = new __parcel__URL__("74852_sq.02bfe37c.jpg").toString();